/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconDone/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconDone({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconDone",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconDone.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-HpAl': alignSelf,'--mt-2-HpAl': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-HpAl': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-HpAl': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-HpAl': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-HpAl': opacity,'--w-10-HpAl': typeof width === 'number' ? `${width}px` : width,'--h-11-HpAl': typeof height === 'number' ? `${height}px` : height,'--a-7-HpAl': isAnimated ? animation : "none",'--sd-8-HpAl': isAnimated ? strokeDashoffset : 0,'--sd-9-HpAl': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconDone.SvgPath"
  data-view-path={viewPath}
 d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
 style={{'--f-12-HpAl': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}